module.exports = __webpack_public_path__ + "img/weibo.e7f6e6cd.jpg";